import React from "react";
import "./FilterPicker.scss";
import "./BestSpots.scss";
import Settings from "./Settings";

const labels = {
  filters: {
    da: "Filtre",
    en: "Filters",
    de: "Filter",
  },
};

/*
 * This component displays the filter picker for the best spots (when best spots sidebar is not open)
 */

const FilterPicker = (props) => {
  return (
    <div
      className="filterPickerContainer"
      style={{ display: props.display ? "block" : "none" }}
    >
      <div className="smallSettingsContainer">
        <h3>{labels.filters[props.language]}</h3>
        <Settings
          coastTypes={props.coastCategories ? props.coastCategories : []}
          fishTypes={props.fishCategories ? props.fishCategories : []}
          settings={props.settings}
          futureMode={props.futureMode}
          newSettings={props.newSettings}
          language={props.language}
        />
      </div>
    </div>
  );
};

export default FilterPicker;
